import { useRef, useState } from "react";
import { ArrowRightLeft, Download, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/components/common";

export default function DataTransfer() {
  const file = useRef(null);
  const [busy, setBusy] = useState(false);
  const download = async () => {
    try {
      const { data } = await api.get("/admin/export", { responseType: "blob" });
      const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(data), download: "ads-monster-content.json" });
      a.click();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/import", await f.text(), { headers: { "Content-Type": "application/json" } });
      toast.success(`Imported: ${Object.entries(data.imported).map(([k, v]) => `${v} ${k}`).join(", ")}`);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <Panel title="Move content to the live app" icon={ArrowRightLeft} testid="data-transfer-panel">
      <p className="mb-4 text-sm text-slate-400">Export the Business Profile, landing pages, campaign plans and audits here, then import the file in the deployed app. Google credentials, logins, leads and execution settings are never included.</p>
      <div className="flex flex-wrap gap-3">
        <button data-testid="data-export-button" onClick={download} className="cc-btn cc-btn-ghost"><Download className="h-4 w-4" /> Export content</button>
        <button data-testid="data-import-button" onClick={() => file.current?.click()} disabled={busy} className="cc-btn cc-btn-ghost"><Upload className="h-4 w-4" /> {busy ? "Importing…" : "Import content"}</button>
        <input ref={file} type="file" accept="application/json" className="hidden" onChange={upload} data-testid="data-import-input" />
      </div>
    </Panel>
  );
}
